import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpenIcon } from 'lucide-react';
export function TheSystem() {
  const tomos = [{
    num: '1',
    title: 'Fisiología del Cambio',
    desc: 'El cuerpo del corredor explicado desde adentro. Mitocondrias, biogénesis, adaptaciones cardiovasculares, zonas de entrenamiento con base fisiológica real. El profe que entiende la fisiología puede explicar a sus alumnos por qué hacen lo que hacen. Y el alumno que entiende por qué se compromete el doble.'
  }, {
    num: '2',
    title: 'Biomecánica y Técnica',
    desc: 'El análisis completo del gesto de carrera. Los vicios técnicos más frecuentes, sus causas biomecánicas y las intervenciones correctivas. Los 15 drills esenciales con instrucciones detalladas. El protocolo de análisis visual que el profe puede aplicar desde el primer día.'
  }, {
    num: '3',
    title: 'Planificación Maestra',
    desc: 'Tu año entero deja de ser un misterio. El sistema completo de macrociclo, mesociclo y microciclo para el corredor amateur. Planes prearmados de 5km, 10km, 21km y maratón listos para personalizar. Nunca más llegás al lunes sin saber hacia dónde vas.'
  }, {
    num: '4',
    title: 'Evaluación y Seguimiento',
    desc: 'Los tests de campo estandarizados, el sistema de monitoreo de la recuperación y los informes mensuales de progreso que convierten tu trabajo invisible en evidencia concreta. La herramienta de retención más poderosa del sistema.'
  }, {
    num: '5',
    title: 'Prevención y Readaptación',
    desc: 'El protocolo completo para anticipar, identificar y abordar las lesiones más frecuentes del corredor. Nunca más llega una lesión y te encuentra sin respuesta. Siempre con el protocolo correcto para cada situación.'
  }, {
    num: '6',
    title: 'El Negocio del Profe Running',
    desc: 'Posicionamiento, precios, las 6 fuentes de ingreso, sistema de contenido y el plan de 90 días para triplicar la facturación sin triplicar las horas. El tomo que ningún profe tiene pero que todos necesitan.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-running-dark" data-id="element-184">
      <div className="max-w-6xl mx-auto" data-id="element-185">
        <FadeIn data-id="element-186">
          <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-187">
            <h2 className="text-4xl sm:text-6xl font-display font-black text-white mb-6 uppercase tracking-tight" data-id="element-188">
              EL <span className="text-running-blue" data-id="element-189">MEGA PACK RUNNING</span>{' '}
              <br data-id="element-190" />
              ES ESE SISTEMA.
            </h2>
            <p className="text-lg sm:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-191">
              No es una colección de PDFs sueltos. No es contenido de Instagram
              organizado. No es teoría académica que se lee y se olvida.
            </p>
            <p className="text-lg sm:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-192">
              Es el sistema completo que transforma la forma en que trabajás
              como profe de running. De la fisiología hasta el negocio. De la
              técnica hasta la recuperación. Del primer alumno hasta el equipo
              de corredores que llevan años con vos.
            </p>
            <p className="text-xl sm:text-2xl font-bold text-white" data-id="element-193">
              Todo conectado. Todo con evidencia. Todo listo para usar desde
              hoy.
            </p>
          </div>
        </FadeIn>

        <FadeIn data-id="element-194">
          <h3 className="text-2xl font-display font-bold text-center text-running-blue mb-10" data-id="element-195">
            Los 6 tomos del sistema principal:
          </h3>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-196">
          {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-197">
              <div className="bg-running-surface border border-running-muted rounded-2xl p-6 sm:p-8 h-full relative overflow-hidden group hover:border-running-blue/40 transition-all" data-id="element-198">
                <div className="absolute top-0 right-0 text-[120px] font-black text-running-dark/80 leading-none -mt-4 -mr-4 pointer-events-none group-hover:text-running-blue/5 transition-colors" data-id="element-199">
                  {tomo.num}
                </div>
                <div className="relative z-10" data-id="element-200">
                  <div className="flex items-center gap-3 mb-4" data-id="element-201">
                    <div className="bg-running-blue/10 text-running-blue p-2 rounded-lg" data-id="element-202">
                      <BookOpenIcon className="w-6 h-6" data-id="element-203" />
                    </div>
                    <span className="text-running-blue font-bold tracking-wider text-sm uppercase" data-id="element-204">
                      Tomo {tomo.num}
                    </span>
                  </div>
                  <h4 className="text-2xl font-display font-bold text-white mb-4" data-id="element-205">
                    {tomo.title}
                  </h4>
                  <p className="text-gray-400 leading-relaxed" data-id="element-206">{tomo.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}